import styled from 'styled-components'
import { themeGet } from 'styled-system'
import SortableAccordionList from 'components/SortableAccordionList'

export const ContentPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5625rem 1.25rem 0.5rem;
  box-sizing: border-box;
  border-radius: 0.625rem;
  background: ${themeGet('colors.white')};
`

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  height: 200px;

  svg {
    color: ${themeGet('colors.darkBlue')};
  }

  p {
    margin-top: 0.25rem;
    margin-left: 0.5rem;
    font-size: 1.125rem;
    font-family: ${themeGet('font.molde.medium')};
    color: ${themeGet('colors.darkGray')};
  }
`

export const NotSetupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 550px;
  box-sizing: border-box;
  background: ${themeGet('colors.white')};
  border-radius: 0.625rem;
`

export const StyledSortableAccordionList = styled(
  SortableAccordionList,
).attrs(({ showTable }) => ({ height: showTable ? 'auto' : '100%' }))`
  height: ${({ height }) => height};
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  [class*='ListHeaderWrapper-sc'] {
    display: grid;
    grid-template-columns: 1.4fr 1.4fr 0.75fr 0.75fr 0.75fr 0.75fr 1.3fr;
    margin-bottom: 0.9375rem;
  }

  @media screen and (max-width: 1245px) {
    [class*='ListHeaderWrapper-sc'] {
      grid-template-columns: 1.2fr 1fr 0.75fr 0.75fr 0.75fr 0.75fr 1fr;
    }
  }

  @media screen and (max-width: 1000px) {
    [class*='ListHeaderWrapper-sc'] {
      grid-template-columns: 1fr 1fr 1fr;
    ]
  }
`
